import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'co0008',
    ecrans: ['00-2']
});
